import { render } from "./DepartmentalMember.vue?vue&type=template&id=0cd8123e&scoped=true&ts=true"
import script from "./DepartmentalMember.vue?vue&type=script&lang=tsx"
export * from "./DepartmentalMember.vue?vue&type=script&lang=tsx"

import "./DepartmentalMember.vue?vue&type=style&index=0&id=0cd8123e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd8123e"]])

export default __exports__